import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { computed } from "@vue/composition-api";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
export const useAdditionalIncomeFieldVisibility = options => {
  const {
    computeSchemaVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIncomePath = computed(() => {
    return currentApplicantPath.value + "[other-income]";
  });
  const currentIncomeVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentIncomePath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.INCOME_HISTORY, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const additionalIncomeAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[amount]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const additionalIncomeDescriptionVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[description]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const additionalIncomeTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const additionalIncomeIncomePeriodVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentIncomeVisibilityPath.value + "[income-period]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const additionalIncomeVisible = computed(() => additionalIncomeAmountVisible.value || additionalIncomeDescriptionVisible.value || additionalIncomeTypeVisible.value || additionalIncomeIncomePeriodVisible.value);
  return {
    additionalIncomeAmountVisible,
    additionalIncomeDescriptionVisible,
    additionalIncomeTypeVisible,
    additionalIncomeIncomePeriodVisible,
    additionalIncomeVisible
  };
};